import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { Provider } from '@shopify/app-bridge-react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import NewExternalUserModal from '../../auth/newexternalusermodal.component.jsx'
import ShopifyAppContext from '../../shopify/shopifyappcontext.js';
const queryString = require('query-string')
const messages = defineMessages({
    "warning": {
        id: 'invoice.pos.warning',
        defaultMessage: 'Warning!',
    },
})

class ShopifyPosSignIn extends Component {
    constructor(props, context) {
        super(props, context)
        const uri = this.props.uri
        if (!uri.response_type) {
            uri.response_type = 'code'
        }
        if (!uri.redirect_uri) {
            uri.redirect_uri = AppContext.getOptions().webCpqUrl + this.props.redirect
        }
        if (!uri.client_id) {
            const options = AppContext.getOptions()
            switch (options.environment) {
                case 'dev':
                    uri.client_id = 'web-cpq'
                    break
                case 'staging':
                    uri.client_id = 'staging-web-cpq'
                    break
                case 'release-candidate':
                    uri.client_id = 'rc-web-cpq'
                    break
                case 'prod':
                    uri.client_id = 'prod-web-cpq'
                    break
            }
        }

        this.state = {
            apiKey: ShopifyAppContext.apiKey,
            uri: uri,
            integrationKey: ShopifyAppContext.integrationKey,
            sessionToken: uri.sessionToken,
            hasKeys: false,
            hasError: false,
            errorType: "",
            shopifyApp: null,
            error: "",
            validated: true,
        }

    }

    componentDidMount() {
        switch (this.state.integrationKey) {
            case ShopifyAppContext.integrationKey: this.handleShopifySignIn(); break
            default: window.location = '/'
        }
    }

    handleShopifySignIn() {
        if (this.state.uri.shop && !this.state.sessionToken) {
            ShopifyAppContext.setOrigin(this.state.uri.shop,this.state.uri.host,this.state.integrationKey)
                .then(_ => ShopifyAppContext.getSessionTokenPromise())
                .then(shopifySessionToken => {
                    AppContext.getApiClient().get('/auth/'+ShopifyAppContext.integrationKey+'/token?' + queryString.stringify(this.state.uri) +
                        `&sessionToken=${shopifySessionToken}`).then(res => {
                            if (res.error) {
                                this.setState({
                                    sessionToken: shopifySessionToken,
                                    validated: false, 
                                    hasError: true,
                                    errorType: res.error.type,
                                    error: res.error.message,
                                })
                            } else {
                                AppContext.getApiClient().addApiKeyHeaders(res)
                                this.setState({ hasKeys: true, sessionToken: shopifySessionToken })
                            }
                        })
                })

        }
    }


    render() {
        const config = {
            apiKey: this.state.apiKey,
            shopOrigin: this.state.uri.shop,
            host: this.state.uri.host
        };
        return this.state.hasKeys ?
            <Provider config={config}>
                {this.props.children}
            </Provider> :
            !this.state.validated && this.state.errorType != "auth_error" ?
                <NewExternalUserModal
                    shopOrigin={this.state.uri.shop}
                    apiKey={this.state.apiKey}
                    redirect={this.props.redirect}
                    isEmbedded={true}
                    integrationKey={this.state.integrationKey}
                    uri={this.state.uri}
                /> :
                this.state.hasError?
                    <div className="alert alert-warning alert-dismissible fade show">
                        <h4 className="alert-heading"><i className="fa fa-warning"></i> {this.props.intl.formatMessage(messages["warning"])}</h4>
                        <div>
                            {
                                this.state.error &&
                                <p>
                                    "{this.state.error}"
                                </p>
                            }
                            <FormattedMessage
                                id="signin.external.please_contact_support"
                                defaultMessage="Please Contact Support at contact@quotemachine.com"
                            />
                        </div>
                    </div> :
                    <div className="text-center">
                        <LoadingSpinner marginTop="20px" />
                        <FormattedMessage
                            id="signin.external.loading"
                            defaultMessage="Signing in to QuoteMachine..."
                        />
                    </div>
    }

}

export default injectIntl(ShopifyPosSignIn)





// WEBPACK FOOTER //
// ./src/embed/shopify/shopifypossignin.component.jsx